import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-step-install-ios-modal',
  templateUrl: './step-install-ios-modal.component.html',
  styleUrls: ['./step-install-ios-modal.component.scss']
})
export class StepInstallIosModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<StepInstallIosModalComponent>, ) { }

  ngOnInit(): void {
  }

  closeModal() {
		this.dialogRef.close()
	}

  onVideoEnded() {
    this.dialogRef.close()
  }

}
